<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import type { ProductLine } from "@shared/types/ProductLine";
  import type { SellSheet } from "@shared/types/SellSheet";
  import SellSheetBuyCart from "./SellSheetBuyCart.svelte";
  import { SellSheetEntity, DistributorEntity } from "@shared/services/event_tracking/entities";

  export let showProductLinks: boolean;
  export let mobileMode: boolean;
  export let productLine: ProductLine;
  export let sellSheet: SellSheet;
  export let isSFList: boolean;

  const arrayCleanup = input => input.toString().replace(/,/gi, ", ");

  const hidePdpLinks =
    productLine.sf_product_version_id && !productLine.cloned_from_product_line_id;
</script>

<div class="grid-row padding-top--small fizz-styles">
  <div class="media">
    <ProductImage
      width={80}
      height={80}
      product={productLine}
      className={"media-fixed distributors__inventory-image margin-right--small"}
    />

    <div class="media-fluid align-self-center">
      <div class="default-subheader--bold">
        {#if hidePdpLinks}
          <span class="color-brandPrimary">{productLine.name}</span>
        {:else}
          <UIRouterLink
            stateName="layout.product_detail"
            params={{
              productId: productLine.cloned_from_product_line_id,
              ssplId: productLine.id,
              shareId: sellSheet.share_id,
            }}
            eventName="sell_sheet_product_name_click"
            useTrackClick
            trackingParams={[
              new SellSheetEntity({
                sheetId: sellSheet.id,
                productLineId: productLine.id,
              }),
              new DistributorEntity({
                id: sellSheet.distributor?.id,
              }),
            ]}
            classes={"color-brandPrimary underline-hover cursor-pointer"}
          >
            {productLine.name}
          </UIRouterLink>
        {/if}
      </div>
      {#if productLine.abv}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">ABV: </span>{productLine.abv}%
        </div>
      {/if}
      {#if productLine.manufacturer}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">Manufacturer: </span>{productLine.manufacturer}
        </div>
      {/if}

      {#if productLine.category}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">Type: </span>{productLine.category}
        </div>
      {/if}

      {#if productLine.product_type_name == "Wine"}
        {#if productLine.vintage_years}
          <div class="default-body--regular margin-top--smallest">
            <span class="fizz-text-strong">Vintage Years: </span>{arrayCleanup(
              productLine.vintage_years,
            )}
          </div>
        {/if}
        {#if productLine.wine_appellation}
          <div class="default-body--regular margin-top--smallest">
            <span class="fizz-text-strong">Wine Appellation: </span>{productLine.wine_appellation}
          </div>
        {/if}
        {#if productLine.wine_region}
          <div class="default-body--regular margin-top--smallest">
            <span class="fizz-text-strong">Wine Region: </span>{productLine.wine_region}
          </div>
        {/if}
        {#if productLine.wine_varietal}
          <div class="default-body--regular margin-top--smallest">
            <span class="fizz-text-strong">Wine Varietal: </span>{productLine.wine_varietal}
          </div>
        {/if}
      {/if}

      {#if productLine.description}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">Description: </span>
          <div style="white-space: pre-wrap;">{productLine.description}</div>
        </div>
      {/if}
      {#if productLine.tasting_notes}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">Tasting Notes: </span>
          <div style="white-space: pre-wrap;">{productLine.tasting_notes}</div>
        </div>
      {/if}
      {#if productLine.additional_notes}
        <div class="default-body--regular margin-top--smallest">
          <span class="fizz-text-strong">Additional Notes: </span>
          <div style="white-space: pre-wrap;">{productLine.additional_notes}</div>
        </div>
      {/if}
    </div>
    <!-- Desktop View Product Buttons -->
    {#if !mobileMode}
      {#if !hidePdpLinks}
        <div class="show--md">
          {#if showProductLinks}
            <div class="media-fixed align-right secondary-body--bold fizz-styles">
              <button class="fizz-button-primary button--primary">
                <UIRouterLink
                  stateName="layout.product_detail"
                  classes="button button--primary color-white"
                  eventName="sell_sheet_view_product_button_click"
                  useTrackClick
                  trackingParams={[
                    new SellSheetEntity({
                      sheetId: sellSheet.id,
                      productLineId: productLine.id,
                    }),
                    new DistributorEntity({
                      id: sellSheet.distributor?.id,
                    }),
                  ]}
                  params={{
                    productId: productLine.cloned_from_product_line_id,
                    ssplId: productLine.id,
                    shareId: sellSheet.share_id,
                  }}
                >
                  View Product
                </UIRouterLink></button
              >
            </div>
          {/if}
          {#if !showProductLinks}
            <div class="media-fixed align-right secondary-body--bold fizz-styles">
              <button class="fizz-button-primary button--primary button--disabled-view-only"
                >View Product</button
              >
            </div>
          {/if}
        </div>
      {/if}
    {/if}
  </div>
  <SellSheetBuyCart
    {productLine}
    {sellSheet}
    {mobileMode}
    {isSFList}
    sellSheetId={sellSheet.id}
    distributor={isSFList ? productLine.distributor : sellSheet.distributor}
  />
</div>
<div class="grid-row"><hr class="hr hr-card-separator" /></div>
